import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IRole {
  Id: string
  Name: string
  UserTypeId: number
}

@Injectable()
export class RoleODataService extends ODataService<IRole> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Roles'
  }
}
